import { QueryKey } from '@/configs/queryKeys';
import { Attachment, UUID, Translations } from '@/types/types';
import EntityApi, { BaseEntity } from './EntityApi';

export enum ContentType {
	TEXT,
	IMAGE,
	ELEMENT,
}

export interface Content extends BaseEntity {
	id: UUID;
	slug: string;
	type: ContentType;
	content: string;
	image: Pick<Attachment, 'id' | 'path'>;
	translations: Translations<{
		content: string;
		image: Pick<Attachment, 'id' | 'path'>;
	}>;
}
class ContentApi extends EntityApi<Content> {
	constructor() {
		super(QueryKey.content);
	}
}

export default new ContentApi();
